import { render, staticRenderFns } from "./HistoricoPepMicro.vue?vue&type=template&id=083a4a5d&scoped=true&"
import script from "./HistoricoPepMicro.vue?vue&type=script&lang=js&"
export * from "./HistoricoPepMicro.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoPepMicro.vue?vue&type=style&index=0&id=083a4a5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083a4a5d",
  null
  
)

export default component.exports